import 'pp-vx/dist/components/checkbox/checkbox.css';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import clsx from 'clsx';

var componentClass = 'ppvx_checkbox';

var renderHelperText = function (text) {
  return text && React.createElement("p", {
    className: "".concat(componentClass, "__helper-text")
  }, text);
};

var renderLabel = function (text, id) {
  return React.createElement("label", {
    className: "".concat(componentClass, "__label"),
    htmlFor: id
  }, text);
};

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "generatedId", "Checkbox_".concat(Math.random().toFixed(8).toString().replace('0.', '')));

    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$id = _this$props.id,
          id = _this$props$id === void 0 ? this.generatedId : _this$props$id,
          label = _this$props.label,
          helperText = _this$props.helperText,
          name = _this$props.name,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, ["id", "label", "helperText", "name", "className"]);

      var classes = clsx(componentClass, className);
      return React.createElement("div", {
        className: classes
      }, React.createElement("input", _extends({
        className: "".concat(componentClass, "__input"),
        type: "checkbox",
        id: id,
        name: name
      }, rest)), renderLabel(label, id), renderHelperText(helperText));
    }
  }]);

  return Checkbox;
}(React.Component);

var componentClass$1 = 'ppvx_checkbox-group';

var CheckboxGroup = function (_ref) {
  var _clsx;

  var label = _ref.label,
      helperText = _ref.helperText,
      errorText = _ref.errorText,
      error = _ref.error,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["label", "helperText", "errorText", "error", "className", "children"]);

  var message = (errorText || helperText) && React.createElement("p", {
    className: clsx((_clsx = {}, _defineProperty(_clsx, "".concat(componentClass$1, "__helper-text"), !error), _defineProperty(_clsx, "".concat(componentClass$1, "__error-text"), error), _clsx))
  }, error ? errorText : helperText);
  return React.createElement("fieldset", _extends({
    className: clsx(componentClass$1, {
      'ppvx_field--error': error
    }, className)
  }, rest), React.createElement("legend", {
    className: "".concat(componentClass$1, "__label")
  }, label), children, message);
};

export { Checkbox, CheckboxGroup };
